import React, { FC, useState } from 'react';
import { TrevorIcon, TrevorIconName } from '../TrevorIcon';
import { Label } from '../TypographyNew';
import { TooltipProps } from './Tooltip.types';
import { CloseButton, TooltipContainer } from './Tooltip.styles';

const ICON_NAME_BY_VARIANT: Record<string, TrevorIconName> = {
  success: 'check-circle',
  error: 'error',
};

export const Tooltip: FC<TooltipProps> = ({
  variant = 'info',
  withClose,
  children,
  forceHidden,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(withClose);

  if (forceHidden) return null;

  const iconName = ICON_NAME_BY_VARIANT[variant];

  return (
    <TooltipContainer
      variant={variant}
      isOpen={isOpen}
      clickable={withClose}
      {...props}
    >
      {iconName && <TrevorIcon name={iconName} />}
      <Label variant={2}>{children}</Label>
      {withClose && <CloseButton onClick={() => setIsOpen(false)} />}
    </TooltipContainer>
  );
};
